import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const V1CRReportUploadRequest = (filePath, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}ServiceDesk/GenerateV1CR`,
	params: { filePath, userId }
});

export const GetTemplateRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ServiceDesk/GetV1CRTemplate`,
	params: { userId }
});
